import { UserContactsGetBlockedListResponse } from "../../proto/UserContactsGetBlockedList_pb";
import store from "../../store";
import { addUserBlocked } from "../../store/users/actions";
import BaseHandler from "../BaseHandler";

export default class HandleUserContactsGetBlockedListResponse extends BaseHandler<UserContactsGetBlockedListResponse> {
  handle() {
    const userContactsGetBlockedListResponse = this.response.toObject();
    store.dispatch(addUserBlocked(userContactsGetBlockedListResponse.userList.map((contact) => contact.userId)));
  }
}
